import alloy from '@assets/images/StoryNarrative/alloy.png';
import ash from '@assets/images/StoryNarrative/ash.png';
import ballad from '@assets/images/StoryNarrative/ballad.png';
import coral from '@assets/images/StoryNarrative/coral.png';
import echo from '@assets/images/StoryNarrative/echo.png';
import fable from '@assets/images/StoryNarrative/fable.png';
import onyx from '@assets/images/StoryNarrative/onyx.png';
import nova from '@assets/images/StoryNarrative/nova.png';
import verse from '@assets/images/StoryNarrative/verse.png';
import sage from '@assets/images/StoryNarrative/sage.png';
import shimmer from '@assets/images/StoryNarrative/shimmer.png';

export interface INarratives {
  voice: string;
  gender: 'woman' | 'man';
  image: string;
}
export const narratives: INarratives[] = [
  {
    voice: 'alloy',
    gender: 'woman',
    image: alloy,
  },
  {
    voice: 'ash',
    gender: 'man',
    image: ash,
  },
  {
    voice: 'ballad',
    gender: 'man',
    image: ballad,
  },
  {
    voice: 'coral',
    gender: 'woman',
    image: coral,
  },
  {
    voice: 'echo',
    gender: 'man',
    image: echo,
  },
  {
    voice: 'fable',
    gender: 'woman',
    image: fable,
  },
  {
    voice: 'onyx',
    gender: 'man',
    image: onyx,
  },
  {
    voice: 'nova',
    gender: 'woman',
    image: nova,
  },
  {
    voice: 'sage',
    gender: 'woman',
    image: sage,
  },
  {
    voice: 'shimmer',
    gender: 'woman',
    image: shimmer,
  },
  {
    voice: 'verse',
    gender: 'man',
    image: verse,
  },
];
